import script from "./ToolFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolFooter.vue?vue&type=script&setup=true&lang=js"

import "./ToolFooter.vue?vue&type=style&index=0&id=68435805&lang=scss&scoped=true"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68435805"]])

export default __exports__